import {
  CommonVariableDefinitionType,
  AutomationVariableDataType,
  Field,
} from 'pages/AutomationEngine/types';
import { TargetFieldVariable } from './subsections/MathOperators/types';

export type ApiVariable = {
  name: string;
  deleted: boolean;
  dataType: AutomationVariableDataType;
  dataSubtype: any | null;
  sourceType: CommonVariableDefinitionType;
  isArray: boolean;
  isArrayItemVariable: boolean;
};

export const apiVariableToOption = (variable: ApiVariable) => ({
  ...variable,
  label: variable.name,
  value: variable.name,
  isVariable: true,
  deleted: false,
  meta: {
    dataType: variable.dataType!,
    dataSubtype: variable.dataSubtype,
    sourceType: variable.sourceType,
  },
});

export const targetFieldVariableToOption = (variable: TargetFieldVariable) => ({
  ...variable,
  label: variable.name,
  value: variable.name,
  isVariable: true,
  deleted: false,
});

export const isManyField = (field: Field) =>
  field.fieldType === 'relationship' &&
  (field.relation.cardinality === 'one_to_many' ||
    field.relation.cardinality === 'many_to_many');
